<template>
  <div class="mt-5 mr-5">
    <CRow style="background-color: transparent !important;">
      <transition appear name="slide" type="animation">
        <CCard style="width: 260px; height: 324px;">
          <CCardHeader class="pb-0">
            <!-- display meatball icon -->
            <CRow>
              <CCol>
                <div v-if="this.$store.getters['auth/userStatus']" @click="showMenu" class="straigtMenu">
                  <i class="fa fa-ellipsis-h fa-2x" color="#B3B3B3" />
                </div>
              </CCol>
            </CRow>

            <!-- display title -->
            <CRow>
              <CCol style="font-size: 5.4rem; font-weight: bold;">{{courseTitle}}</CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <!-- for click area -->
            <div @click="sendCourseData(data)">
              <!-- display fullname -->
              <CRow>
                <CCol>
                  <p
                    style="font-size: 1.5rem; margin-bottom: 0.5rem; font-weight: bold; overflow: hidden;text-overflow: ellipsis;"
                  >{{ data.subtitle[0].val }}</p>
                </CCol>
              </CRow>

              <!-- display  study hrs-->
              <CRow>
                <CCol class="description">Study hours</CCol>
                <CCol class="text-right description">{{data.studyHour}}</CCol>
              </CRow>

              <!-- display Category -->
              <CRow>
                <CCol class="description">Category</CCol>
                <div v-if="data.categorys !== null">
                  <CCol class="text-right description">
                    {{categorysName}}
                  </CCol>
                </div>
                <div v-else>
                  <CCol class="text-right description">
                    {{categoryName}}
                    <br />
                    <div style="margin-top: -0.2rem"></div>
                  </CCol>
                </div>
              </CRow>

              <!-- display views -->
              <CRow>
                <CCol class="description">views</CCol>
                <CCol class="text-right description">
                  <div v-if="data.views">{{data.views.length}}</div>
                  <div v-else>0</div>
                </CCol>
              </CRow>
            </div>

            <!-- display progress bar and button -->
            <CRow class="mt-3">
              <CCol>
                <CProgress
                  showPercentage
                  :value="data.studyHour"
                  :max="max"
                  class="progressBar"
                  show-value
                  border-radius="50px"
                >
                  <CProgressBar style="border-radius:20px; background-color: #2a4388"></CProgressBar>
                </CProgress>
              </CCol>
              <CCol class="text-right overviewIcon">
                <!-- <router-link to="/Exprofile"> -->
                <img
                  src="@/assets/icons/homepage/GotoOverview.svg"
                  alt="overview"
                  width="43"
                  height="43"
                />
                <!-- </router-link> -->
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </transition>

      <!-- display menu -->
      <transition name="slide" type="animation">
        <div v-show="showingMenu" class="ml-3">
          <div v-for="(item, index) in menu" :key="index">
            <span
              v-c-tooltip.click.hover="{
                    content: item.name,
                    placement: 'right',
                    }"
              @click="clickIcon(item.name)"
              style="border-radius: 50%; padding-left: 0.3rem;padding-right: 0.3rem;padding-top: 0.15rem; padding-bottom: 0.15rem;background: white; box-shadow: 1px 1px 2px black;"
            >
              <i
                :class="item.icon"
                :color="item.color"
                style="height: 16px; width: 16px; margin-top: 0.95rem;"
              />
            </span>
          </div>
        </div>
      </transition>
    </CRow>
    <CModal
      add-content-classes="bg-transparent border-0 pl-5"
      :no-close-on-backdrop="true"
      :centered="true"
      :show.sync="isVisible"
      @click="onPressUnenrollModal()"
      :closeOnBackdrop="false"
    >
      <template #header-wrapper>
        <div class="closeBtnContainer" @click="isVisible=false">
          <p class="closeButton">
            <img
              src="@/assets/icons/closeButton.svg"
              style="background-color: white; border-radius: 50%;"
            />
          </p>
        </div>
      </template>
      <template #footer-wrapper>
        <div></div>
      </template>
      <template #body-wrapper>
        <div class="modal-content tab widthLoginModal">
          <div class="modal-text">
            <div class="p-3 mt-1">
              <b
                style="color:black;
                font: Bold 22px/32px Roboto;
              letter-spacing: 0px;
              opacity: 1;
              margin-bottom: 0px;
              margin-top: 20px
                "
              >Are you sure you want to unenroll from</b>
              <br />
              <h3
                style="color: #BD2531
              font: Bold 24px/32px Roboto;
              letter-spacing: 0px;
              color: #BD2531;
              opacity: 1;
              margin-bottom: 0px;
              margin-top: 20px
              margin-left: 125px;
              margin-left:125px;
              "
              >CHINESE 1</h3>
              <br />
              <div style="text-align:center">
                <p
                  style="margin-bottom:0pxtext-align: left;
                font: Bold 14px/19px Roboto;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;

                "
                >Your feedback helps MDL improve</p>
                <p
                  style="margin-bottom:0pxtext-align: left;
                font: Bold 14px/19px Roboto;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;"
                >Please tell us why you're unenrolling (optional)</p>
              </div>
              <br />

              <select name id class="drobdown_modal">
                <option
                  value
                  disabled
                  selected
                  style="opacity: 1;font-size: 16px;"
                >Select your reason for Unenrolling</option>
                <option value="I don't like the course">I don't like the course</option>
                <option value="The course was too hard">The course was too hard</option>
                <option value="The course was too easy">The course was too easy</option>
                <option value="Didn't meet expectations">Didn't meet expectations</option>
                <option value="I prefer not to say">I prefer not to say</option>
                <option value="Other">Other</option>
              </select>
              <br />
              <br />
              <div style="display: flex;flex-direction: row;justify-content: center;">
                <CButton
                  color="secondary"
                  class="button"
                  style="background-color: gray;"
                  @click="isVisible=false"
                >CANCEL</CButton>
                <CButton
                  color="secondary"
                  class="button"
                  style="background-color: dodgerblue;"
                  @click="DeleteCourse()"
                >UNENROLL</CButton>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CModal>
    <!-- ------------------------------------------------------------Cmodal-------------------------------------------------------------- -->
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";

export default {
  data() {
    return {
      courseTitle: "",
      categorysName: "",
      dataHolder: {},
      isVisible: false,
      showingMenu: false,
      // value: 100,
      max: 100,
      menu: [
        {
          name: "star",
          status: false,
          color: "gray",
          icon: "fas fa-star",
        },
        {
          name: "overview",
          status: false,
          color: " #6868FF",
          icon: "fas fa-eye",
        },
        {
          name: "progress",
          status: false,
          color: "#58C958",
          icon: "fas fa-flag",
        },
        {
          name: "share",
          status: false,
          color: "#6767FF",
          icon: "fas fa-share-square",
        },
        {
          name: "unenrolled",
          status: false,
          color: "#FF5050",
          icon: "fas fa-ban",
        },
      ],
    };
  },
  props: {
    data: Object,
  },
  watch: {},
  mounted() {
    this.dataHolder = this.data;
    this.checkLanguage();
  },
  methods: {
    checkLanguage() {
      if (this.dataHolder.title) {
        for (let index = 0; index < this.dataHolder.title.length; index++) {
          const TitlaName = this.dataHolder.title[index];
          if (TitlaName.key == "en") {
            this.courseTitle = TitlaName.val;
          }
          // ลูบ key เพื่อให้แสดงภาษา ENG of title 
        }
      }
      if (this.data.categorys) {
        for (let index = 0; index < this.data.categorys.length; index++) {
          const element = this.data.categorys[index];
          const element2 = element.category.title;
          for (let index2 = 0; index2 < element2.length; index2++) {
            const element3 = element2[index2];
            if (element3.key == "en") {
              this.categorysName = element3.val;
              // ลูบ key เพื่อให้แสดงภาษา Eng of category
            }
          }
        }
      }
    },
    routeToNextPageWithParams() {
      // $router.push('/overview')
    },
    sendCourseData(data) {
      let courseCodeData = {
        courseCode: data.code,
        objectId: data._id,
      };
      this.$store.commit("dataCourse", courseCodeData);
      this.$router.push({
        name: "Overview",
        // params: {
        //   courseCode: data.code,
        //   objectId : data._id
        // }
      });
    },
    showMenu() {
      this.showingMenu = !this.showingMenu;
    },
    clickIcon(icon) {
      if (icon == "unenrolled") {
        this.onPressUnenrollModal();
      }
      if (icon == "star") {
        alert(
          "Icon name = " + icon + " with course id = " + this.dataHolder.code
        );
      }
      if (icon == "progress") {
        // คำสั่ง Navigation
        this.$router.push("/InprogressCourseDetail");
      }
      if (icon == "overview") {
        this.$router.push("/Overview");
      }
    },
    onPressUnenrollModal() {
      this.isVisible = true;
    },
    DeleteCourse() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.card {
  box-shadow: 5px 5px 10px #0000004d;
  background-color: #2a4388;
  border: white;
  border-radius: 40px;
  color: white;
  transition: transform 0.2s;
}

.card-header {
  background-color: transparent;
  border: none;
  padding-top: 0px;
}

.card-body {
  padding: 0rem 1.25rem;
}

.card:hover {
  cursor: pointer;
  transition-delay: 0.3s;
  transform: scale(1.1);
}

.straigtMenu {
  z-index: 999;
  margin-right: -0.3rem;
  position: absolute;
  background: white;
  height: 40px;
  width: 57px;
  text-align: end;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 40px;
}

.straigtMenu:hover {
  filter: brightness(70%);
}

.progressBar {
  width: 9rem;
  height: 43px;
  border-radius: 50px;
  box-shadow: none;
  padding: 5px;
  overflow: visible;
}

.overviewIcon:hover {
  /* -webkit-filter: brightness(70%); */
  filter: brightness(0.4);
}

.description {
  font-size: 0.875rem;
}

/* -- ---------------------------------------------------------- CSS MODAL -------------------------------------------------- -- */

.closeButton {
  align-content: flex-end;
  float: right;
  width: 26px;
  height: 26px;
  padding-top: -100px;
  margin-right: 12px;
  cursor: pointer;
  margin-bottom: 0.1em;
}

.button {
  outline: none;
  border: none;
  width: 12rem;
  text-align: center;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 40px;
  font-size: 16px;
  margin: 10px;
}

.drobdown_modal {
  width: 90%;
  border: 0px;
  border-bottom: 1px solid #cccccc;
  margin-left: 20px;
}

.modal-text p {
  font-weight: 300;
  font-size: 16px;
  color: black;
  margin-bottom: 0px;
}

.modal-text h1 {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-content p {
  font-size: 24px;
  margin-top: 0.6em;
}

.tab {
  border-top-right-radius: 30px;
  border-top-left-radius: 30px;
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.widthLoginModal {
  width: 420px;
  position: inherit;
}

.slide-enter {
  opacity: 0;
}

.slide-enter-active {
  transition: opacity 0.4s;
  animation: slide-in 0.4s ease-out forwards;
}

/* .slide-leave {
} */

.slide-leave-active {
  transition: opacity 0.4s;
  opacity: 0;
  animation: slide-out 0.4s ease-in forwards;
}

@keyframes slide-in {
  from {
    transform: translateX(-1.5rem);
  }
  to {
    transform: translateX(0rem);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0rem);
  }
  to {
    transform: translateX(-1.5rem);
  }
}
</style>
